import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, InputAdornment, FormHelperText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useZone } from "../ZoneContext";
import { useZoneActions } from "../ZoneContext";
import { useFormValidation } from '../validations';

const BasicFields = ({ rows, selectedRow }) => {
    const { t } = useTranslation();
    const zone = useZone();
    const data = zone.general;
    const { existName } = useFormValidation(rows, selectedRow);
    const { updateField, changeType } = useZoneActions();


    const FORM_TYPES = {
        HOLIDAY: 'holiday',
        WEEK_DAYS: 'week_days',
        CONSECUTIVE_DAYS_WORKED: 'consecutive_days_worked',
        DIFERENTIAL_DAILY_EXTEND_ZONE_RULE: 'diferential_daily_extend_zone_rule',
        DIFERENTIAL_WEEKLY_EXTEND_DAILY: 'diferential_weekly_extend_daily'
    };


    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <TextField
                    id="name"
                    name="name"
                    label={t('settings.zones.fields.name')}
                    variant="outlined"
                    value={data.name}
                    onChange={(e) => updateField('general', 'name', e.target.value)}
                    error={existName}
                    slotProps={{
                        htmlInput: { maxLength: 100 },
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    {`${data.name.length}/100`}
                                </InputAdornment>
                            )
                        }
                    }}
                    required
                    autoComplete="off"
                    autoFocus
                    fullWidth
                />
                <FormHelperText error>
                    {existName ? t('settings.zones.fields.exist_name') : ''}
                </FormHelperText>
            </Grid>
            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <FormControl fullWidth required>
                    <InputLabel id="types">
                        {t('settings.zones.fields.type.title')}
                    </InputLabel>
                    <Select
                        id="types"
                        name="types"
                        labelId="types"
                        value={data.type}
                        variant="outlined"
                        label={t('settings.zones.fields.type.title')}
                        onChange={(e) => changeType(e.target.value)}
                    >
                        {Object.values(FORM_TYPES).map(type => (
                            <MenuItem key={type} value={type}>
                                {t(`settings.zones.fields.type.${type}`)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                    id="description"
                    name="description"
                    label={t('settings.zones.fields.description')}
                    variant="outlined"
                    value={data.description}
                    onChange={(e) => updateField('general', 'description', e.target.value)}
                    rows={2}
                    multiline
                    slotProps={{
                        htmlInput: { maxLength: 255 },
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    {`${data.description.length}/255`}
                                </InputAdornment>
                            )
                        }
                    }}
                    autoComplete="off"
                    fullWidth
                />
        </Grid>
    </Grid>
)};

export { BasicFields };